var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip"},[_c('div',{staticClass:"tooltip__title",class:{ item: _vm.type === 'deliveryItem' }},[_c('img',{attrs:{"src":require('@/assets/img/ic_qmark.svg')}}),_c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.getTitle)}}),_c('div',{staticClass:"tooltip__content",domProps:{"innerHTML":_vm._s(_vm.getContent)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }